module.exports = __webpack_public_path__ + "img/august_320.05a186b8.png";